export default __webpack_public_path__ + "static/media/workdayscheduler.243e0531.gif";